/** An announcement for people who cannot see the screen change.
 *
 * Filtering the queue swaps 87 rows for 4 with no sound and no focus movement.
 * A sighted user sees the grid redraw; a screen-reader user gets nothing at all
 * unless something says so out loud. This is that something.
 *
 * `polite` rather than `assertive` throughout: a result count is worth saying at
 * the next natural pause, not worth interrupting whatever is being read.
 *
 * The node is always in the tree, even when the message is empty. A live region
 * that is mounted at the same moment its text arrives is frequently missed —
 * assistive technology watches an existing region for changes, so it has to be
 * there first.
 */
export function LiveRegion({ message }: { message: string }) {
  return (
    <div role="status" aria-live="polite" aria-atomic="true" className="sr-only">
      {message}
    </div>
  )
}
